import React, { useContext } from 'react';
import { NavLink, Link } from 'react-router-dom';
import './HeaderButton.css';
import home from '../../../Media/Home.svg';
import performance from '../../../Media/Perfomance.svg';
import calendar from '../../../Media/Calendar.svg';
import notify from '../../../Media/Notify.svg';
import current from '../../../Media/CurrTasks.svg';
import booking from '../../../Media/Calendar.svg';
import courses from '../../../Media/Courses.svg';
import infinityImg from '../../../Media/Infinity.svg';
import calendarBooking from '../../../Media/CalendarBooking.svg'
const HeaderButton = ({ type, active, onClickAction, number, activeBtn }) => {
    const setButtonIcon = (type) => {
        switch (type) {
            case 'home':
                return home;
            case 'cap':
                return performance;
            case 'calendar':
                return calendar;
            case 'current':
                return current;
            case 'notify':
                return notify;
            case 'booking':
                return calendarBooking;
            case 'courses':
                return courses;
            case 'calendarBooking': 
                return calendarBooking;
            default:
                return '';
        }
    };
    console.log(number);
    const handleNumberNotification = (num) => {
        const lengthNotify = num.filter((e) => e.is_read === false);
        return lengthNotify.length > 99 ? infinityImg : lengthNotify.length;
    };
    return (<>
        <div className={`header__button ${activeBtn}`} onClick={onClickAction}>
            <img src={setButtonIcon(type)} alt='icon' className='header__buttonIcon' />
            {active ? (
                <div className='header__redNotify'>{typeof handleNumberNotification(number) === 'string' ?  <img className='header__redNotify_img' src={handleNumberNotification(number)} alt="Infinity" /> : <span>{handleNumberNotification(number)}</span>}</div>
            ) : (
                ''
            )}
        </div>
        </>
    );
};
export default HeaderButton;
